import React, { useState } from "react";
import Modal from "../../common/Modal/Modal";
import { HelpOutline } from "@mui/icons-material";
import CategoriesTooltips from "./CategoriesTooltips";

import "./CategoriesModal.css";


//This Modal shows information details about categories: start, pathway, comparator, value, pico

export default function CategoriesModal() {
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false); //close the success modal
  };

  const modalButtons = [
    {
      label: "button-close", //submit button inside the modal
      className: "button-close",
      onClick: handleCloseModal, // Call the handleSaveForLater function
    },
  ];
  const arrayData = JSON.parse(
    localStorage.getItem("UpdatedDataArray")
  );

  return (
    <div className="categories-modal-tooltip">
      <button className="categories-modal-button" onClick={handleOpenModal}>
        <HelpOutline />
      </button>
      <Modal
        isOpen={openModal}
        onClose={handleCloseModal}
        title={"Categories"}
        showCustomContent={true}
        customContent={
          <div className="categories-body">
            <CategoriesTooltips selectedFileData={arrayData} />
          </div>
        }
      />
    </div>
  );
}
